module.exports = __webpack_public_path__ + "static/media/user.5c859888.png";